module.exports = __webpack_public_path__ + "img/bg103_19.075b2c40.png";